var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"context-list",class:{ 'context-list--visible': _vm.visible }},[_vm._t("default",null,{"items":_vm.items,"select":_vm.select,"displayFn":_vm.displayFn})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }